import { Injectable, inject } from '@angular/core';

import { HrtApiService } from '@shared/services/hrt-api/hrt-api.service';

export interface DemoAccountResetStatus {
  operationId: string | null;
  state: 'Idle' | 'Queued' | 'Running' | 'Completed' | 'Failed';
  startedAtUtc?: string;
  completedAtUtc?: string;
  error?: string;
}

@Injectable({
  providedIn: 'root',
})
export class DemoAccountApiService {
  readonly api = inject(HrtApiService);

  createData() {
    return this.api.post<DemoAccountResetStatus>('DemoAccount/create', null);
  }

  getStatus() {
    return this.api.get<DemoAccountResetStatus>('DemoAccount/status');
  }
}
